/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchPostsV2.defs.js'
export { main as default } from './searchPostsV2.defs.js'
